/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetNotificationResponse } from './GetNotificationResponse';
import {
    GetNotificationResponseFromJSON,
    GetNotificationResponseFromJSONTyped,
    GetNotificationResponseToJSON,
    GetNotificationResponseToJSONTyped,
} from './GetNotificationResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetNotificationResponse
 */
export interface PaginatedResultOfGetNotificationResponse {
    /**
     * 
     * @type {Array<GetNotificationResponse>}
     * @memberof PaginatedResultOfGetNotificationResponse
     */
    items?: Array<GetNotificationResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetNotificationResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetNotificationResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetNotificationResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetNotificationResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetNotificationResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetNotificationResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetNotificationResponse interface.
 */
export function instanceOfPaginatedResultOfGetNotificationResponse(value: object): value is PaginatedResultOfGetNotificationResponse {
    return true;
}

export function PaginatedResultOfGetNotificationResponseFromJSON(json: any): PaginatedResultOfGetNotificationResponse {
    return PaginatedResultOfGetNotificationResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetNotificationResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetNotificationResponseToJSON(json: any): PaginatedResultOfGetNotificationResponse {
    return PaginatedResultOfGetNotificationResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetNotificationResponseToJSONTyped(value?: PaginatedResultOfGetNotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetNotificationResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

